/** Month `month`'s name, January the 1st, in `language`. */
export const MonthName = (month: number, language: string): string =>
  new Intl.DateTimeFormat(language, { month: "long", timeZone: "UTC" }).format(
    Date.UTC(2001, month - 1, 1)
  )
